import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.05 6.3A.884.884 0 016.3 5.05l3.7 3.7 3.7-3.7a.884.884 0 011.25 1.25l-3.7 3.7 3.7 3.7a.884.884 0 01-1.25 1.25l-3.7-3.7-3.7 3.7a.884.884 0 01-1.25-1.25l3.7-3.7-3.7-3.7z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
